export const ID_FILTER_REPORT_CREATIONDATEFROM ="createdDateFrom";
export const ID_FILTER_REPORT_CREATIONDATETO ="createdDateTo";
export const ID_FILTER_PREVIEW_INTERMEDIARY = "intermediary";
export const ID_FILTER_PRINTOUT_INTERMEDIARY = "intermediaryName";
export const ID_FILTER_PRINTOUT_CREATIONDATEFROM ="creationDateFrom";
export const ID_FILTER_PRINTOUT_CREATIONDATETO ="creationDateTo";
export const ID_FILTER_LEGAL_ENTITIES ="legal-entities";
export const ID_FILTER_DEALERS ="dealers"; 